export default "__VITE_ASSET__ntK15_gl__"